// extracted by mini-css-extract-plugin
export default {"item":"forgot-password-email_item__IA6g0"};